import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { Pane, toaster, Button, TextInputField } from "evergreen-ui";
import gql from "graphql-tag";

const CHANGE_USER = gql`
  mutation ChangeUser($id: String!, $password: String!) {
    changeUser(_id: $id, password: $password)
  }
`;

export default ({ userId }) => {
  const [password, setPassword] = useState("");
  // const [old, setOld] = useState("");
  const [changeUser] = useMutation(CHANGE_USER, {
    onCompleted: () => {
      setPassword("");
      // setOld("");
      toaster.success("Pomyślnie zmieniono hasło");
    }
  });

  return (
    <Pane>
      <Pane fontSize={18} paddingBottom={8}>
        Zmiana hasła
      </Pane>
      <Pane maxWidth={480}>
        {/* <TextInputField
          label="Stare hasło"
          placeholder="Wpisz hasło..."
          value={old}
          onChange={e => setOld(e.target.value)}
        /> */}
        <TextInputField
          label="Nowe hasło"
          placeholder="Wpisz hasło..."
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
        />
        <Button
          onClick={() => {
            changeUser({
              variables: {
                id: userId,
                password: password
              }
            });
          }}
        >
          Zmień hasło
        </Button>
      </Pane>
    </Pane>
  );
};
